export function teamAccordion() {
  return {
    openCategories: [0], // First category open by default
    
    toggleCategory(index) {
      if (this.openCategories.includes(index)) {
        // Remove from array if already open
        this.openCategories = this.openCategories.filter(i => i !== index);
      } else {
        // Add to array if closed
        this.openCategories.push(index);
      }
    },
    
    isCategoryOpen(index) {
      return this.openCategories.includes(index);
    }
  };
}